import { useState, useEffect } from 'react';
import { analyzeWallet } from './analyzerCore';

// Analyse fraîche à chaque exécution : aucun cache, aucune persistance.
// L'analyse ne démarre que si `runId` > 0 (clic explicite sur "Analyser" ou "Rafraîchir") :
// changer `address` seul ne déclenche jamais d'appel (chaque analyse coûte des crédits).
export function useAnalyzer(address, runId, apiKey) {
  const [state, setState] = useState({ data: null, loading: false, error: null });

  useEffect(() => {
    if (!address || !runId) { setState({ data: null, loading: false, error: null }); return undefined; }
    const ctrl = new AbortController();
    setState({ data: null, loading: true, error: null });
    analyzeWallet(address, apiKey, ctrl.signal)
      .then(data => { if (!ctrl.signal.aborted) setState({ data, loading: false, error: null }); })
      .catch(e => { if (!ctrl.signal.aborted) setState({ data: null, loading: false, error: e.message || 'Erreur' }); });
    return () => ctrl.abort();
  // apiKey lue au lancement uniquement : la modifier ne relance pas l'analyse
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address, runId]);

  return state;
}
